"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Option", {
  enumerable: true,
  get: function get() {
    return _rcSelect.Option;
  }
});
exports.InputSelectFormControl = exports["default"] = exports.RawInputSelect = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _rcSelect = _interopRequireWildcard(require("rc-select"));

var _FormBaseWrapper = _interopRequireDefault(require("../FormBaseWrapper"));

var _ThemeProvider = require("../../ThemeProvider");

var _antStyle = _interopRequireDefault(require("./ant.style.js"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var defaultFilter = function defaultFilter(input, option) {
  return option.props.text.toLowerCase().includes(input.toLowerCase());
};

var AntSelect = function AntSelect(_ref) {
  var id = _ref.id,
      classes = _ref.classes,
      handleChange = _ref.handleChange,
      _ref$filterOption = _ref.filterOption,
      filterOption = _ref$filterOption === void 0 ? defaultFilter : _ref$filterOption,
      _ref$localization = _ref.localization,
      l = _ref$localization === void 0 ? function (key) {
    return key;
  } : _ref$localization,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["id", "classes", "handleChange", "filterOption", "localization"]);
  return /*#__PURE__*/_react["default"].createElement(_rcSelect["default"], (0, _extends2["default"])({
    filterOption: filterOption,
    onChange: handleChange,
    classes: classes,
    id: id,
    notFoundContent: l('Not found')
  }, props));
};

AntSelect.propTypes = {
  id: _propTypes["default"].string,
  classes: _propTypes["default"].object,
  handleChange: _propTypes["default"].func,
  filterOption: _propTypes["default"].func,
  localization: _propTypes["default"].func
};
var ThemedSelect = (0, _ThemeProvider.withStyles)(_antStyle["default"])(AntSelect);
exports["default"] = exports.RawInputSelect = ThemedSelect;

var InputSelectFormControl = function InputSelectFormControl(props) {
  return /*#__PURE__*/_react["default"].createElement(_FormBaseWrapper["default"], (0, _extends2["default"])({
    Control: ThemedSelect
  }, props));
};

exports.InputSelectFormControl = InputSelectFormControl;
//# sourceMappingURL=ant.js.map